"use client";

import { useEffect, useRef } from "react";


export default function ContactHero() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".scroll-fade-up").forEach((el, i) => {
              setTimeout(() => el.classList.add("is-visible"), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="pt-32 pb-16 bg-hero-gradient relative overflow-hidden"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <div className="scroll-fade-up">
          <span className="teal-badge mb-5">Get In Touch</span>
        </div>
        <h1 className="text-5xl sm:text-6xl font-extrabold text-[#1A2B2B] tracking-tight leading-tight mb-6 scroll-fade-up">
          We're here to{" "}
          <span className="gradient-text">help</span>
        </h1>
        <p className="text-lg sm:text-xl text-[#4A6363] max-w-2xl mx-auto leading-relaxed scroll-fade-up">
          Have a question, feedback, or need support? Our team responds to all inquiries within 24 hours.
        </p>
      </div>
    </section>
  );
}